import * as BABYLON from "babylonjs";
import "babylonjs-loaders";

export default class CameraController {
  constructor(scene, canvas) {
    this.scene = scene;
    this.canvas = canvas;
    this.camera = this.createCamera(); // Appel immédiat pour créer la caméra
    this.createCameraCollider(); // Appel immédiat pour créer le collider
  }

  createCamera() {
    // Utilisation de TouchCamera au lieu de UniversalCamera
    const camera = new BABYLON.TouchCamera("TouchCamera", new BABYLON.Vector3(0, 1.75, 0), this.scene);

    // Réglage des propriétés pour adapter la caméra à un usage tactile
    camera.speed = 0.4;  // Vitesse de déplacement
    camera.inertia = 0.7;  // Inertie des mouvements
    camera.angularSensibility = 1000;  // Sensibilité à la rotation pour le mode PC

    // Propriétés tactiles pour ajuster la rotation horizontale (gauche/droite)
    camera.touchAngularSensibility = 2500;  // Sensibilité de la rotation horizontale sur mobile
    camera.touchMoveSensibility = 250;  // Sensibilité du mouvement avant/arrière

    // Autres réglages de la caméra pour l'environnement
    camera.position = new BABYLON.Vector3(-15.80, 8.42, -8.28);
    camera.setTarget(new BABYLON.Vector3(1.47, 1.83, -18.86));
    
    camera.applyGravity = true;
    camera.checkCollisions = true;
    camera.ellipsoid = new BABYLON.Vector3(0.5, 1, 0.5);

    // Réglage de la gravité pour la scène
    this.scene.gravity = new BABYLON.Vector3(0, -9.81, 0);

    // Attacher les contrôles de la caméra au canvas
    camera.attachControl(this.canvas, true);

    return camera;
  }

  createCameraCollider() {
    const collider = BABYLON.MeshBuilder.CreateBox("cameraCollider", { height: 2, width: 0.6, depth: 0.6 }, this.scene);
    collider.isVisible = false;
    collider.isPickable = true;
    collider.checkCollisions = false;

    collider.parent = this.camera;
    collider.position = new BABYLON.Vector3(0, -1.75, 0);

    this.cameraCollider = collider;
  }

  getCameraCollider() {
    return this.cameraCollider;
  }

  updateCameraPosition(position) {
    if (this.camera) {
      this.camera.position = position;
    }
  }

  dispose() {
    this.camera?.dispose();
    this.cameraCollider?.dispose();
  }
}